import { z } from 'zod';

/**
 * 内容审核设置（system_settings.content_moderation）：
 * - 文本：提示词与素材名称按敏感词库拦截（政治、国家敏感等），命中返回 422；
 * 图片与视频素材不做内容审核（只做文件类型与安全校验，见 apps/server/src/modules/assets/probe.ts）。
 */
export const ContentModerationSettingsSchema = z.object({
  enabled: z.boolean(),
  /** 敏感词：中文按子串匹配（忽略空格与标点），英文按整词匹配；不区分大小写与全半角 */
  keywords: z.array(z.string().trim().min(1).max(64)).max(5000),
  /** 是否同时检查素材名称 */
  check_asset_names: z.boolean(),
});
export type ContentModerationSettings = z.infer<typeof ContentModerationSettingsSchema>;

/** GET /admin/settings/content-moderation */
export const AdminContentModerationSchema = ContentModerationSettingsSchema;
export type AdminContentModeration = z.infer<typeof AdminContentModerationSchema>;
